import { ConstructionInhomogeneousLayer } from "@/types/Views/CreateConstruction/NewConstruction";
import ConstructionAmountCalculator from "..";

const calculateInhomogeneousLayerWeight = (
  inhomogeneousLayer: ConstructionInhomogeneousLayer,
  constructionDeclaredUnitId: number
) => {
  const calculator = ConstructionAmountCalculator.fromInhomogeneousLayer(inhomogeneousLayer, constructionDeclaredUnitId);

  return inhomogeneousLayer.materials.reduce<number>((acc, constructionMaterial) => {
    const newDeclaredUnit = constructionMaterial.material?.declaredUnit;
    const newWeightPerDeclaredUnit = constructionMaterial.material?.weightPerDeclaredUnit;

    if (!newDeclaredUnit || !newWeightPerDeclaredUnit) {
      return acc;
    }

    const weight = calculator.toConstructionMaterial(constructionMaterial).calculate(constructionMaterial).weight;

    return acc + weight;
  }, 0);
};

export default calculateInhomogeneousLayerWeight;
